<template>
  <div class="forgot-password">
    <b-modal
      @change="change"
      :visible="visible"
      hide-footer
      hide-header
      centered
    >
      <h3 class="text-center px-4 pt-2">
        Digite seu e-mail de cadastro
      </h3>

      <div class="text-center px-4 pt-2 pb-4">
        Você receberá, em seu e-mail, o link para redefenir a sua senha
      </div>

      <form @submit.prevent="submit">
        <form-group
          v-model="email"
          id="email"
          type="email"
          placeholder="Digite a seu e-mail"
          :errors="errors.email"
        />

        <div class="row">
          <div class="col pr-5">
            <button
              class="btn btn-block btn-light text-muted btn-strong"
              type="button"
              @click="close"
            >
              Fechar
            </button>
          </div>
          <div class="col pl-5">
            <button
              class="btn btn-block btn-primary btn-strong"
              type="submit"
              :disabled="loading"
            >
              <b-spinner v-show="loading" variant="light" small></b-spinner>
              <span v-show="!loading">Enviar</span>
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      defaul: false
    }
  },
  data() {
    return {
      loading: false,
      email: "",
      errors: {
        email: null
      }
    };
  },
  model: {
    prop: "visible",
    event: "change"
  },
  methods: {
    close() {
      this.$emit("change", false);
    },
    change(val) {
      this.$emit("change", val);
    },
    submit() {
      this.loading = true;

      this.$store
        .dispatch("user/forgot", { email: this.email })
        .then(() => {
          this.loading = false;
          this.$message.success("Enviado com sucesso, confira o seu email");
          this.close();
        })
        .catch(error => {
          this.errors = error.response.data;
          this.loading = false;
        });
    }
  }
};
</script>
